import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app'
import { getMessaging, Messaging, getToken, onMessage } from 'firebase/messaging'
import { getAnalytics } from 'firebase/analytics'

import { notifications_realisation } from '@/core/realisations/notifications.realisation'

import { useNotificationsStore } from '@/modules/NotificationsModule/store/useNotificationsStore'

const FIREBASE_CFG: FirebaseOptions = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
}

const FIREBASE_VAPID_KEY: string = process.env.VUE_APP_FIREBASE_VAPID_KEY as string

export default function () {
    let firebase_app: FirebaseApp | null = null
    let messaging: Messaging | null = null

    const notifications_store = useNotificationsStore()

    async function getPermission(): Promise<NotificationPermission> {
        const permission = Notification.permission

        if (permission === 'default') {
            return await Notification.requestPermission()
        }

        return permission
    }

    async function initialize() {
        try {
            const permission = await getPermission()
            if (permission !== 'granted') {
                return
            }

            firebase_app = initializeApp(FIREBASE_CFG)
            messaging = getMessaging(firebase_app)

            const token = await getToken(messaging, { vapidKey: FIREBASE_VAPID_KEY })

            await notifications_realisation.setDeviceToken(token)

            getAnalytics(firebase_app)

            onMessage(messaging, (payload: any) => {
                notifications_store.loadNotifications({ page: 1 })

                const title = payload.notification.title

                const options = {
                    body: payload.notification.body,
                    icon: payload.notification.icon,
                }

                const browser_notification = new Notification(title, options)

                browser_notification.onclick = function (event: Event) {
                    event.preventDefault()

                    if (window) {
                        const url = payload.data.link
                        window.open(url, '_blank')
                    }
                }
            })

            console.log('[useFirebase] Firebase initialized')
        } catch (error) {
            console.error('[useFirebase] Failed to initialize firebase app')
            console.error(error)
        }
    }

    return { initialize }
}
